
export const CHECK_AUTH = "me"
export const LOGIN = "login"
export const MESSAGES_API = "messages"
export const INBOXS_API = "inboxs"
export const USERS_API = "agents"
export const CONVERSATIONS_API = "conversations"
export const REPLIES_API = "agentresponse"
export const CATEGORIE_LIST_API = "glpicategories"
export const TICKETS_API = "addTicket"
export const SAVE_ONLY_API = "savesupport"
export const NEW_CONVERSATION_API = "newConversation"



